import React, { PropTypes } from "react";
import { intlShape } from "react-intl";
import ClientHeaderSelector from "./ClientHeaderSelector";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as clientActions from "./clients/client/clientActions";

class ClientSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            clients: [],
            activeClientId: null,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleClientSelect = this.handleClientSelect.bind(this);
    }

    componentDidMount() {
        let clients = [];
        try {
            let parsed = JSON.parse(sessionStorage.getItem("associatedClients"));
            if (Array.isArray(parsed)) {
                clients = parsed
                    .filter(function (c) {
                        return c && typeof c.name === "string" && c.clientId != null;
                    })
                    .map((c) => {
                        return {
                            value: c.clientId,
                            label: c.name,
                        };
                    });
            }
        } catch (e) {
            clients = [];
        }

        // Extract active clientId from the current URL pathname
        // Path format: /dashboard/clients/:clientId/...
        let pathname = window.location.pathname;
        let parts = pathname.split("/");
        let clientsIndex = parts.indexOf("clients");
        let activeClientId = clientsIndex !== -1 ? parts[clientsIndex + 1] : null;

        this.setState({
            clients: clients,
            activeClientId: activeClientId,
        });
    }

    openModal() {
        this.setState({ showModal: true });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    /**
     * Converts clients array to SelectInput option format, sorted alphabetically.
     */
    getClientOptions() {
        if (!this.state.clients || this.state.clients.length === 0) {
            return [];
        }

        return this.state.clients
            .slice()
            .sort(function (a, b) {
                return a.name.localeCompare(b.name);
            })
            .map(function (client) {
                return {
                    value: String(client.clientId),
                    text: client.name,
                };
            });
    }

    /**
     * Navigates to the selected client's page with a full reload.
     */
    handleClientSelect(client, activeClientObj) {
        const numericId = Number(client.value);
        const activeClientNumericId = Number(activeClientObj.id);

        if (!Number.isInteger(numericId) || numericId <= 0) {
            return;
        }

        if (numericId === activeClientNumericId) {
            return;
        }

        let clientId = String(numericId);
        let pathname = window.location.pathname;
        let parts = pathname.split("/");
        let clientsIndex = parts.indexOf("clients");

        if (clientsIndex !== -1 && parts.length > clientsIndex + 1) {
            // Redirect to the client root page
            window.location.href = parts
                .slice(0, clientsIndex + 1)
                .concat(clientId)
                .join("/");
        }
    }

    /**
     * Returns the name of the currently active client, or empty string if not found.
     */
    getActiveClientObj() {
        let activeClientId = this.state.activeClientId;
        let activeClient = this.state.clients.filter(function (c) {
            return String(c.value) === String(activeClientId);
        })[0];
        return activeClient ? { id: activeClientId, name: activeClient.label } : {};
    }

    render() {
        // Hidden when user has 0 or 1 client
        if (this.state.clients.length <= 1) {
            return null;
        }

        let activeClientObj = this.getActiveClientObj();
        if (activeClientObj && !this.props.clientSelectorClient) {
            /**
             * Used for default client selection
             */
            this.props.clientActions.setClientSelectorClient({ id: activeClientObj.id, name: activeClientObj.name });
        }
        return (
            <div>
                <div className="client-selector-trigger">
                    {this.props.clientSelectorClient && (
                        <ClientHeaderSelector
                            selectedClient={{ value: this.props.clientSelectorClient.id, label: this.props.clientSelectorClient.name }}
                            clients={this.state.clients}
                            onClientChange={(client) => this.handleClientSelect(client, this.props.clientSelectorClient)}
                        />
                    )}
                </div>
            </div>
        );
    }
}

ClientSelector.propTypes = {
    clientSelectorClient: PropTypes.object,
    clientActions: PropTypes.object
};

ClientSelector.contextTypes = {
    router: PropTypes.object,
    intl: intlShape
};

function mapStateToProps(state) {
    return {
        clientSelectorClient: state.clientActions.client,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clientActions: bindActionCreators(clientActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientSelector);



// WEBPACK FOOTER //
// ./src/components/dashboard/ClientSelector.js